import styled from "styled-components";
import {SearchInputMobileDefaultBox} from "./search-input-mobile.default.box";

export const SearchInputMobileCasino777Box = styled(SearchInputMobileDefaultBox)`
      padding: 1rem;
      background: linear-gradient(-45deg, rgba(252,246,213,0.8) 33.33%, rgba(25,50,47,0.1) 33.33%, rgba(25,50,47,0.2) 50%, rgba(252,246,213,0.8) 50%, rgba(252,246,213,0.8) 83.33%, rgba(25,50,47,0.1) 83.33%, rgba(25,50,47,0.1) 100%);
      background-size: 4px 4px;
      border-radius: 5px;
      box-shadow: 2px 3px 1rem rgba(25,50,48,0.2);
`;